import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { failedResponse, getBackendUrl, loaded, loading, error, LoadStateInfo, LoadState } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { RootState } from "../../app/store";

export interface RetrieveConversationPartyUsersRequest {
    conversationId: string;
    partyId: string;
}

export const retrieveConversationPartyUsers = createAsyncThunk(
    "retrieveConversationPartyUsers",
    async (param: RetrieveConversationPartyUsersRequest, thunkAPI) => {
        console.debug("retrieve conversation party users");

        const response = await fetch(`${getBackendUrl()}/api/conversation/${param.conversationId}/${param.partyId}/users`, {
            signal: thunkAPI.signal,
            headers: {
                "Authorization": `Bearer ${getToken()}`,
            }
        });

        if (response.ok) {
            return await response.json();
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    },
    {
        condition: (param: RetrieveConversationPartyUsersRequest, thunkAPI) => {
            const state = thunkAPI.getState() as RootState;
            const status = state.conversationPartyUsers.partyUsers[param.partyId];
            if(!status || !status.state) {
                return true;
            }
            if (status.state.state == LoadState.NotStarted) {
                return true;
            }
            return false;
        }
    }
);

export interface ConversationPartyUser {
    id: string;
    conversationId: string;
    partyId: string;
    userId: string;
}
export interface ConversationPartyUsersState {
    state: LoadStateInfo;
    list?: ConversationPartyUser[]
}

export interface ConversationMessagesState {
    partyUsers: Record<string, ConversationPartyUsersState>;
}

const initialState: ConversationMessagesState = {
    partyUsers: {},
};

export const conversationPartyUsersSlice = createSlice({
    name: "conversatonPartyUsers",
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(retrieveConversationPartyUsers.pending, (state, action) => {
                if(! state.partyUsers[action.meta.arg.partyId]) {
                    state.partyUsers[action.meta.arg.partyId] = {
                        state: loading(),
                        list: [],
                    };
                }
            })
            .addCase(retrieveConversationPartyUsers.fulfilled, (state, action) => {
                console.debug(`${action.type}`);
                state.partyUsers[action.meta.arg.partyId].state = loaded();
                state.partyUsers[action.meta.arg.partyId].list = action.payload;
            })
            .addCase(retrieveConversationPartyUsers.rejected, (state, action) => {
                state.partyUsers[action.meta.arg.partyId].state = error(action);
            });
    },
});

export const { } = conversationPartyUsersSlice.actions;

export const selectConversationPartyUsers = (state: RootState) => state.conversationPartyUsers;

export default conversationPartyUsersSlice.reducer;
